
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OfferCardDiscountLabel',
  props: {
    percents: {
      type: Number,
      default: 0,
    },
    discountDayLeft: {
      type: Number,
      default: 0,
    },
    size: {
      type: String as () => 'sm' | 'md',
      default: 'md',
    },
    theme: {
      type: String as () => 'dark' | 'default',
      default: 'default',
    },
  },
})
